import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getOnlineStoreSessions = {
  name: "getOnlineStoreSessions" as const,
  input: z.object({
    /**
     * Optional date range. Both bounds are required when present.
     * When absent, sessions will be null (ShopifyQL requires explicit date bounds).
     */
    dateRange: z
      .object({ start: zExt.instant(), end: zExt.instant() })
      .optional(),
  }),
  output: z.object({
    /** Total online store sessions for the period, or null when unavailable. */
    sessions: z.number().nullable(),
  }),
};
